<div fxLayout="column" mat-dialog-title>
  {{ data.subject }}
  <div class="info" fxFlex="noshrink" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="start" fxLayoutAlign.gt-xs="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="column">
        <div class="from">Systeem</div>
        <div class="to secondary-text" fxLayout="row" fxLayoutAlign="start center">
          to {{ data.recipient }}
        </div>
      </div>
    </div>
    <div class="extra" fxFlexAlign.xs="end" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
      <div class="when secondary-text">{{ data.created_at | date:'dd-MM-Y HH:mm' }}</div>
    </div>
  </div>
</div>
<mat-dialog-content>
  <div class="inbox-mail" fxFlex="grow" fxLayout="column">
    <div class="mail-content" fxLayout="column">
      <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(data.content)" class="content" fxFlex="grow"
           style="line-height:29px;font-size:16px;"></div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-raised-button>ANNULEREN</button>
</mat-dialog-actions>
